var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "w-100pct h-60px cl-white f-s-18px f-w-bold pd-18px",
        style: "background-color: " + _vm.mainColor + ";"
      },
      [
        _c(
          "router-link",
          { attrs: { to: { name: "Cart" } } },
          [
            _c("svg-filler", {
              staticClass: "mg-r-auto f-left cs-pointer",
              attrs: {
                path: "/static/svg/back.svg",
                fill: "#ffffff",
                width: "20px",
                height: "20px"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("span", [_vm._v("\n      ช่องทางการชำระเงิน\n    ")])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "w-100pct h-60calc" }, [
      _c("div", { staticClass: "t-al-center f-s-24px f-w-bold pd-t-48px" }, [
        _vm._v(
          "\n      ราคา " +
            _vm._s(_vm._f("showFullPriceFormat")(_vm.netPrice)) +
            " บาท\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "t-al-center f-s-18px mg-t-48px" },
        [
          _c("router-link", { attrs: { to: { name: "CheckoutByCard" } } }, [
            _c("img", {
              staticClass: "w-174px",
              attrs: { src: "/static/svg/credit.svg" }
            }),
            _vm._v(" "),
            _c("br")
          ]),
          _vm._v("\n      ชำระด้วยบัตรเครดิต\n    ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "t-al-center f-s-18px mg-t-48px" },
        [
          _c("router-link", { attrs: { to: { name: "CheckoutByCash" } } }, [
            _c("img", {
              staticClass: "w-174px",
              attrs: { src: "/static/svg/cash.svg" }
            }),
            _vm._v(" "),
            _c("br")
          ]),
          _vm._v("\n      ชำระด้วยเงินสด\n    ")
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-129e8794", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-129e8794","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/check-out/Payment.vue
// module id = 464
// module chunks = 1